import React from 'react';
import { FAQ_PATH } from '../routes';

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <h3 className="text-white font-bold text-lg mb-3">
              <span className="text-indigo-400">learnweb</span>care.com
            </h3>
            <p className="text-sm leading-relaxed">Professional subscription management and after-sales support you can trust.</p>
          </div>

          <div>
          </div>

          <div>
            {/* <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Contact</h4> */}
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/" className="hover:text-indigo-400 transition-colors">Home</a></li>
              <li><a href={FAQ_PATH} className="hover:text-indigo-400 transition-colors">FAQs</a></li>
              {/* <li className="flex items-center gap-2"><FiMail className="w-4 h-4 text-indigo-400" /> support@learnwebacademy.net</li> */}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 text-center text-xs text-slate-500">
          &copy; 2026 learnwebcare.com &mdash; All rights reserved.
        </div>
      </div>
    </footer>
  );
}
